module.exports = __webpack_public_path__ + "static/media/nus_logo_vertical.a5ea317c.jpg";